module.exports = __webpack_public_path__ + "aa6bffe92d8b43dc0c96733dfd01ae6c.svg";